"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogSchema = exports.AuditAction = void 0;
const z = __importStar(require("zod"));
/**
 * ============================================================================
 * AUDIT LOG MODEL - PLACEHOLDER
 * ============================================================================
 *
 * ⚠️  NOTE: This model is a PLACEHOLDER for the audit logging system.
 *
 * The backend currently does NOT have:
 * - Audit logging database schema
 * - Audit log creation/retrieval endpoints
 * - Audit log service implementation
 *
 * This model defines the structure for when audit logging is implemented.
 * Frontend uses mock data for testing until backend endpoints are ready.
 *
 * Backend Implementation TODO:
 * 1. Create AuditLog table in Prisma schema
 * 2. Implement AuditLog service for recording actions
 * 3. Add audit log endpoints (GET /users/:id/audit-logs, etc.)
 * 4. Implement middleware to automatically capture actions
 *
 * DO NOT REMOVE - Required by frontend user management features
 * ============================================================================
 */
var AuditAction;
(function (AuditAction) {
    // User Management Actions
    AuditAction["USER_CREATED"] = "USER_CREATED";
    AuditAction["USER_UPDATED"] = "USER_UPDATED";
    AuditAction["USER_ROLE_CHANGED"] = "USER_ROLE_CHANGED";
    AuditAction["USER_DEACTIVATED"] = "USER_DEACTIVATED";
    AuditAction["USER_REINSTATED"] = "USER_REINSTATED";
    AuditAction["USER_DELETED"] = "USER_DELETED";
    // Invitation Actions
    AuditAction["INVITATION_CREATED"] = "INVITATION_CREATED";
    AuditAction["INVITATION_ACCEPTED"] = "INVITATION_ACCEPTED";
    AuditAction["INVITATION_RESENT"] = "INVITATION_RESENT";
    AuditAction["INVITATION_REVOKED"] = "INVITATION_REVOKED";
    AuditAction["INVITATION_EXPIRED"] = "INVITATION_EXPIRED";
    // Access & Auth Actions
    AuditAction["LOGIN"] = "LOGIN";
    AuditAction["LOGOUT"] = "LOGOUT";
    AuditAction["PASSWORD_RESET"] = "PASSWORD_RESET";
})(AuditAction || (exports.AuditAction = AuditAction = {}));
exports.AuditLogSchema = z.object({
    id: z.string(),
    /**
     * The action that was performed (from AuditAction enum)
     */
    action: z.nativeEnum(AuditAction),
    /**
     * ID of the user who performed the action
     */
    actorId: z.string(),
    /**
     * ID of the user/entity being acted upon (optional - may be null for some actions)
     */
    targetId: z.string().nullable().optional(),
    /**
     * Email of the target user (useful for audit trails of deleted users)
     */
    targetEmail: z.string().email().optional(),
    /**
     * Additional context about the action (JSON object)
     */
    details: z.record(z.unknown()).optional(),
    /**
     * IP address of the requester
     */
    ipAddress: z.string().optional(),
    /**
     * User agent of the requester
     */
    userAgent: z.string().optional(),
    /**
     * Timestamp when the action was recorded
     */
    createdAt: z.date(),
});
